import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form } from "react-bootstrap";
// import SelectStudentModal from "../AdminAttendanceEntry/SelectStudentModal";
import { ApiUrl } from "../../../ApiUrl";
import Select from "react-select";

const AdmAttendanceEntry = () => {
  const [classOptions, setClassOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [mentors, setMentors] = useState([]);

  const [subjectOptions, setSubjectOptions] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [timeTableData, setTimeTableData] = useState([]);
  const [organizedData, setOrganizedData] = useState([]);

  // State for filters

  const dateFromRef = useRef(null);
  const dateToRef = useRef(null);
  const messageTypeRef = useRef(null);
  const studentNameRef = useRef(null);
  const initiatedByRef = useRef(null);
  const sectionRef = useRef(null);
  const classRef = useRef(null);

  const handleClear = () => {
    if (dateFromRef.current) dateFromRef.current.value = "";
    if (dateToRef.current) dateToRef.current.value = "";
    if (messageTypeRef.current) messageTypeRef.current.value = "";
    if (studentNameRef.current) studentNameRef.current.value = "";
    if (initiatedByRef.current) initiatedByRef.current.value = "";
    if (sectionRef.current) sectionRef.current.value = "";
    if (classRef.current) classRef.current.value = "";
  };

  useEffect(() => {
    const fetchSectionData = async () => {
      if (!selectedClass) {
        setSectionOptions([]); // Clear sections if no class is selected
        return;
      }

      console.log("Fetching sections for classId:", selectedClass.value); // Debugging

      try {
        const response = await fetch(
          `${ApiUrl.apiurl}ClassSectionBind/GetAllSectionBindWithClass/${selectedClass.value}`
        );
        const data = await response.json();

        console.log("Section API response:", data); // Debugging

        if (data.message === "success") {
          const formattedSections = data.data.map((sectionItem) => ({
            value: sectionItem.section_id,
            label: sectionItem.sectionname,
          }));
          setSectionOptions(formattedSections);
        } else {
          console.error("Failed to fetch sections: ", data.message);
          setSectionOptions([]);
        }
      } catch (error) {
        console.error("Error fetching section data:", error);
        setSectionOptions([]);
      }
    };

    fetchSectionData();
  }, [selectedClass]);

  // Fetch all classes
  useEffect(() => {
    fetch(`${ApiUrl.apiurl}Class/GetAllClass/`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.data) {
          const options = data.data.map((cls) => ({
            value: cls.id,
            label: cls.classname,
          }));
          setClassOptions([{ value: "", label: "Select Class" }, ...options]);
        }
      })
      .catch((error) => {
        console.error("Error fetching class data:", error);
      });
  }, []);

  useEffect(() => {
    const fetchMentors = async () => {
      try {
        const orgId = localStorage.getItem("orgId");
        const branchId = localStorage.getItem("branchId");

        if (!orgId || !branchId) {
          console.error("Missing orgId or branchId in localStorage");
          return;
        }

        const response = await fetch(
          `${ApiUrl.apiurl}Teacher/GetEmployeeList/?orgId=${orgId}&branchId=${branchId}`
        );
        const data = await response.json();
        if (data && data.data) {
          // Mapping data to match React Select options format
          const formattedMentors = data.data.map((mentor) => ({
            value: mentor.id,
            label: mentor.employeeName,
          }));
          setMentors(formattedMentors);
        }
      } catch (error) {
        console.error("Error fetching mentors:", error);
      }
    };

    fetchMentors();
  }, []);

  useEffect(() => {
    const fetchSubjects = async () => {
      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");
      const academicSessionId = localStorage.getItem("academicSessionId");
      if (!selectedClass) {
        setSubjectOptions([]);
        return;
      }
  
      const classId = selectedClass.value;
      const sectionId = selectedSection ? selectedSection.value : 0;
  
      const searchParams = new URLSearchParams({
        academic_year_id: academicSessionId,
        org_id: orgId,
        branch_id: branchId,
        class_id: classId,
      });

      const fetchSubjectOptions = async (params) => {
        const response = await fetch(
          `${ApiUrl.apiurl}SUBJECTS/GetSubjectListBasedOnClassAndSection/?${params.toString()}`
        );

        if (response.status === 204) {
          return [];
        }

        const data = await response.json();

        if (data?.message === "success" && Array.isArray(data.data)) {
          return data.data.map((subject) => ({
            value: subject.id,
            label: subject.subjectcode,
          }));
        }

        return [];
      };

      try {
        let options = [];

        if (selectedSection) {
          const sectionParams = new URLSearchParams(searchParams);
          sectionParams.set("section_id", sectionId);
          options = await fetchSubjectOptions(sectionParams);
        }

        if (options.length === 0) {
          options = await fetchSubjectOptions(searchParams);
        }

        setSubjectOptions([
          { value: "", label: "Select Subject" },
          ...options,
        ]);
      } catch (error) {
        console.error("Error fetching subject data:", error);
        setSubjectOptions([{ value: "", label: "Select Subject" }]);
      }
    };
  
    fetchSubjects();
  }, [selectedClass, selectedSection]);
  

  // useEffect(() => {
  //   fetchTimeTableData();
  // }, []);

  // const fetchTimeTableData = async () => {
  //   try {
  //     const orgId = localStorage.getItem("orgId") || "";
  //     const branchId = localStorage.getItem("branchId") || "";
  //     const academicYearId = localStorage.getItem("academicSessionId") || "";

  //     const response = await fetch(
  //       `${ApiUrl.apiurl}TIME_TABLE/GetSearchedTimeTableList/?academic_year_id=${academicYearId}&org_id=${orgId}&branch_id=${branchId}`
  //     );
  //     const data = await response.json();

  //     if (data.message === "success" && Array.isArray(data.data)) {
  //       setTimeTableData(data.data);
  //     } else {
  //       setTimeTableData([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching timetable data:", error);
  //     setTimeTableData([]);
  //   }
  // };

  // Days of the week for the table header

  useEffect(() => {
    generateCalendar();
  }, []);

  useEffect(() => {
    generateCalendar();
  }, []);

useEffect(() => {
  if (selectedMentor) {
    fetchTimeTableData();
  } else {
    setTimeTableData([]);
  }
}, [selectedMentor, selectedClass, selectedSection, selectedSubject]);

  const generateCalendar = () => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    let calendar = [];
    let week = new Array(7).fill(null);

    for (let i = 0; i < firstDay.getDay(); i++) {
      week[i] = null; // Empty cells before the first day
    }

    for (let date = 1; date <= lastDay.getDate(); date++) {
      const dayOfWeek = new Date(
        today.getFullYear(),
        today.getMonth(),
        date
      ).getDay();
      week[dayOfWeek] = { date, dayOfWeek }; // Store date and day index

      if (dayOfWeek === 6 || date === lastDay.getDate()) {
        calendar.push(week);
        week = new Array(7).fill(null);
      }
    }

    setOrganizedData(calendar);
  };

  const fetchTimeTableData = async () => {
    try {
      const orgId = localStorage.getItem("orgId") || "";
      const branchId = localStorage.getItem("branchId") || "";
      const academicYearId = localStorage.getItem("academicSessionId") || "";

      const params = new URLSearchParams({
        academic_year_id: academicYearId,
        org_id: orgId,
        branch_id: branchId,
        teacher_id: selectedMentor ? selectedMentor.value : "",
        class_id: selectedClass ? selectedClass.value : "",
        section_id: selectedSection ? selectedSection.value : "",
        subject_id: selectedSubject ? selectedSubject.value : "",
      });

      const response = await fetch(
        `${
          ApiUrl.apiurl
        }TIME_TABLE/GetSearchedTimeTableList/?${params.toString()}`
      );

      const data = response.status === 204
        ? { message: "No Record Found", data: [] }
        : await response.json();
      if (data.message === "success" && Array.isArray(data.data)) {
        setTimeTableData(data.data);
      } else {
        setTimeTableData([]); // Ensures "No Data Found" appears when no results
      }
    } catch (error) {
      console.error("Error fetching timetable data:", error);
      setTimeTableData([]);
    }
  };

  // Convert schedule_day (e.g., "MONDAY") to day index (0 = Sunday, 6 = Saturday)
  const getDayIndex = (day) => {
    return daysOfWeek.findIndex((d) => d.toUpperCase() === day.toUpperCase());
  };

  const daysOfWeek = [
    "SUNDAY",
    "MONDAY",
    "TUESDAY",
    "WEDNESDAY",
    "THURSDAY",
    "FRIDAY",
    "SATURDAY",
  ];

  // Organizing data by day
  // const organizedData = daysOfWeek.map((day) =>
  //   timeTableData.filter((entry) => entry.schedule_day === day)
  // );

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                TEACHER TIME TABLE
              </p>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1">
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="teacher" className="form-label">
                          Teacher
                        </label>
                        <Select
                          id="mentor"
                          options={mentors}
                          className="detail"
                          value={selectedMentor}
                          onChange={setSelectedMentor}
                          placeholder="Select Mentor"
                          classNamePrefix="mentor-dropdown"
                        />
                      </div>
                      <div className="col-md-3 ">
                        <label htmlFor="class" className="form-label">
                          Class
                        </label>

                        <Select
                          options={classOptions}
                          className="detail"
                          classNamePrefix="class-dropdown"
                          placeholder="Select Class"
                          value={selectedClass}
                          onChange={setSelectedClass} // Set selected class
                        />
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="section" className="form-label">
                          Section
                        </label>
                        <Select
                          options={sectionOptions}
                          className="detail"
                          classNamePrefix="section-dropdown"
                          placeholder="Select Section"
                          isDisabled={!selectedClass}
                          value={selectedSection} // Add this line to maintain state
                          onChange={setSelectedSection} // Add this line to update state
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-3">
                        <label htmlFor="subject" className="form-label">
                          Subject
                        </label>
                        <Select
                          options={subjectOptions}
                          className="detail"
                          classNamePrefix="subject-dropdown"
                          placeholder="Select Subject"
                          isDisabled={!selectedClass} // Disable if no class is selected
                          value={selectedSubject}
                          onChange={setSelectedSubject}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        {daysOfWeek.map((day) => (
                          <th
                            key={day}
                            className="text-center bg-primary text-white"
                          >
                            {day}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {organizedData.map((week, i) => (
                        <tr key={i}>
                          {week.map((cell, j) => (
                            <td
                              key={j}
                              className="text-center"
                              style={{ minHeight: "100px" }}
                            >
                              {cell ? <strong>{cell.date}</strong> : ""}
                              <div>
                                {cell &&
                                  timeTableData
                                    .filter(
                                      (entry) =>
                                        getDayIndex(entry.schedule_day) ===
                                        cell.dayOfWeek
                                    )
                                    .map((entry, index) => (
                                      <div key={index} className="p-1 border">
                                        <strong>Class:</strong> {entry.class}{" "}
                                        <br />
                                        <strong>Section:</strong>{" "}
                                        {entry.section} <br />
                                        <strong>Period:</strong>{" "}
                                        {entry.class_period} <br />
                                        <strong>Subject:</strong>{" "}
                                        {entry.subject} <br />
                                        <strong>Teacher:</strong>{" "}
                                        {entry.teacher_name} <br />
                                      </div>
                                    ))}
                              </div>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
